module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"New Booking":"Neue Anmeldung","Export":"Exportieren","Show filters":"Filter anzeigen","Hide filters":"Filter verbergen","Booking list could not be fetched.":"Buchungsliste konnte nicht abgerufen werden."}}')
  delete Component.options._Ctor
}
